import { queryClient } from 'App';

export default async () => {
  await queryClient.invalidateQueries(['featureFlags']);
};
